module.exports = __webpack_public_path__ + "static/media/clownfish.6c41fe6e.svg";